var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1231_10482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.773 17.3408C21.1948 16.3755 20.3353 13.6444 20.3353 10.0773C20.3353 7.93505 19.4572 5.88056 17.8941 4.36578C16.331 2.851 14.211 2 12.0005 2C9.79 2 7.67002 2.851 6.10695 4.36578C4.54387 5.88056 3.66575 7.93505 3.66575 10.0773C3.66575 13.6454 2.80518 16.3755 2.22696 17.3408C2.0793 17.5861 2.00102 17.8649 2.00001 18.149C1.999 18.4331 2.07531 18.7124 2.22123 18.9587C2.36714 19.2051 2.57752 19.4098 2.83113 19.5523C3.08474 19.6947 3.37263 19.7698 3.66575 19.77H7.91752C8.10982 20.6819 8.62121 21.5014 9.3652 22.09C10.1092 22.6785 11.0401 23 12.0005 23C12.9609 23 13.8918 22.6785 14.6358 22.09C15.3798 21.5014 15.8912 20.6819 16.0835 19.77H20.3353C20.6283 19.7696 20.9161 19.6944 21.1695 19.5519C21.423 19.4094 21.6332 19.2046 21.779 18.9583C21.9248 18.712 22.001 18.4327 22 18.1487C21.9989 17.8648 21.9207 17.5861 21.773 17.3408ZM12.0005 21.3855C11.4836 21.3853 10.9794 21.2299 10.5574 20.9406C10.1353 20.6513 9.81618 20.2423 9.64386 19.77H14.3572C14.1849 20.2423 13.8657 20.6513 13.4437 20.9406C13.0217 21.2299 12.5175 21.3853 12.0005 21.3855ZM3.66575 18.1545C4.46797 16.8178 5.3327 13.7201 5.3327 10.0773C5.3327 8.36349 6.0352 6.7199 7.28566 5.50808C8.53612 4.29625 10.2321 3.61545 12.0005 3.61545C13.7689 3.61545 15.4649 4.29625 16.7154 5.50808C17.9658 6.7199 18.6683 8.36349 18.6683 10.0773C18.6683 13.7171 19.531 16.8147 20.3353 18.1545H3.66575Z",
    fill: "current",
    stroke: "none"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1231_10482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/Reminder.762e1aa400c475bdb8c195d8ccd47d80.svg";
export { ForwardRef as ReactComponent };